import { Platform } from 'quasar';

/**
 * Whether a field in the filter dialog takes focus as it appears.
 *
 * On a pointer device it saves a click on every pane that leads with a search field. On a touch
 * device it opens the keyboard instead, and the dialog remounts its field on each step into a
 * group or a criterion, so navigating means dismissing the keyboard over and over for a field the
 * user may never type in.
 *
 * @returns {boolean}
 */
export default function shouldAutofocus() {
  return !Platform.is.mobile;
}
